import { getDrawInfoDetail } from '@/api';
import { urlFormatToJump } from '../../service/router';
import { jumpToApp } from '../../utils/tools';
export default {
  name: 'RednotePage',
  data() {
    return {
      // 活动ID参数
      activity_id: this.$route.query.activity_id,
      // 数据模型
      prizeModel: {
        activity_info: {
          activity_id: '',
          status: 3,
          // 0进行中 1开奖中 2开奖成功 3不开奖
          title: '',
          join_number: 0,
          prize_type: 2,
          // 1奖品 2购买权 3审核
          describe: '',
          draw_rule: '',
          on_time_distribute_txt: '',
          end_time: '',
          rednote_link: '',
          share_code: ''
        },
        item_info: {
          item_id: '',
          item_type: 1,
          item_type_name: '众筹',
          title: ' ',
          jump_url: ''
        },
        prize_list: [],
        condition_list: [] // 参与条件列表
      },
      selectedPrizeIndex: 0,
      loading: false,
      error: ''
    };
  },
  mounted() {
    this.getPrizeDetail();
  },
  methods: {
    // 方法
    selectPrize(index) {
      this.selectedPrizeIndex = index;
    },
    getCurrentPrize() {
      // 获取当前选中的奖品，如果没有奖品则返回默认对象
      if (this.prizeModel.prize_list && this.prizeModel.prize_list.length > 0) {
        return this.prizeModel.prize_list[this.selectedPrizeIndex] || this.prizeModel.prize_list[0];
      }
      return {
        img: '',
        prize_name: '暂无奖品',
        num: 0,
        relation_type: 1,
        price: '',
        jump_url: ''
      };
    },
    getTotalPrizeCount() {
      // 计算所有奖品的总数量
      if (this.prizeModel.prize_list && this.prizeModel.prize_list.length > 0) {
        return this.prizeModel.prize_list.reduce((total, prize) => total + (prize.num || 0), 0);
      }
      return 0;
    },
    handlePrizeClick() {
      this.guideToApp();
    },
    //项目点击
    handleProjectClick() {
      if (this.prizeModel.item_info.jump_url) {
        urlFormatToJump(this.prizeModel.item_info.jump_url);
      }
    },
    handleUploadLink() {
      this.guideToApp();
    },
    // 底部按钮相关方法
    shouldShowBottomButton() {
      const status = this.prizeModel.activity_info.status;
      // 1: 开奖中  2: 已开奖
      return status === 1 || status === 2;
    },
    getBottomButtonText() {
      const status = this.prizeModel.activity_info.status;
      switch (status) {
        case 1:
          // 开奖中
          return '活动结束，开奖中~';
        case 2:
          // 已开奖
          return '查看中奖结果';
        default:
          return '';
      }
    },
    getBottomButtonClass() {
      const status = this.prizeModel.activity_info.status;
      switch (status) {
        case 1:
          // 开奖中 - 灰色背景
          return 'button-drawing';
        case 2:
          // 已开奖 - 白色背景带边框
          return 'button-result';
        default:
          return '';
      }
    },
    handleBottomButtonClick() {
      this.guideToApp();
    },
    async guideToApp() {
      try {
        await jumpToApp({
          type: 'prizeDetail_V5',
          id: this.activity_id
        });
      } catch (error) {
        // jumpToApp 内部已经处理了错误提示
        console.error('跳转APP失败:', error);
      }
    },
    // 获取参与者头像显示数量
    getParticipantAvatarCount() {
      return Math.min(this.prizeModel.activity_info.join_number, 8);
    },
    // 获取活动状态类型 (green/gray)
    getActivityStatusType() {
      const status = this.prizeModel.activity_info.status;
      switch (status) {
        case 0: // 进行中
        case 1:
          // 开奖中
          return 'green';
        case 2:
          // 已开奖
          return this.prizeModel.activity_info.is_win_prize === 1 ? 'green' : 'gray';
        case 3: // 活动已取消
        case 4: // 众筹未成功，活动已取消
        default:
          return 'gray';
      }
    },
    // 获取活动标题文案
    getActivityHeadingText() {
      const status = this.prizeModel.activity_info.status;
      switch (status) {
        case 0:
          // 进行中
          return `开奖截止时间 ${this.prizeModel.activity_info.end_time}`;
        case 1:
          // 开奖中
          return '活动结束，开奖中~';
        case 2:
          // 已开奖
          return this.prizeModel.activity_info.is_win_prize === 1 ? '恭喜！你已中奖！' : '抱歉，你未中奖';
        case 3:
          // 活动已取消
          return '活动已取消';
        case 4:
          // 众筹未成功，活动已取消
          return '众筹未成功，活动已取消';
        default:
          return '';
      }
    },
    // 获取背景图片URL
    getActivityBackgroundImage() {
      return this.getActivityStatusType() === 'green' ? 'https://p6.moimg.net/wxapp/prize_detail_status_back.png' : 'https://p6.moimg.net/wxapp/prize_detail_status_back_gray.png';
    },
    // 获取礼品图标URL
    getActivityGiftImage() {
      return this.getActivityStatusType() === 'green' ? 'https://p6.moimg.net/wxapp/prize_detail_gift_green.png' : 'https://p6.moimg.net/wxapp/prize_detail_gift_gray.png';
    },
    // 获取查看结果箭头图片URL
    getResultArrowImage() {
      // 已中奖使用白色箭头，未中奖使用灰色箭头
      return this.prizeModel.activity_info.is_win_prize === 1 ? 'https://p6.moimg.net/wxapp/prize_detail_arrow_white.png' : 'https://p6.moimg.net/wxapp/prize_detail_arrow_gray.png';
    },
    // 查看结果按钮点击事件
    handleViewResult() {
      this.guideToApp();
    },
    // 条件列表相关方法
    getConditionItemClass(status) {
      switch (status) {
        case 20:
          return 'completed';
        case 10:
          return 'available';
        default:
          return 'pending';
      }
    },
    // 获取条件按钮样式类
    getConditionButtonClass(status) {
      switch (status) {
        case 0: // 未完成 - 绿色
        case 10:
          // 领取 - 绿色
          return 'button-green';
        case 20: // 已完成 - 灰色
        default:
          return 'button-gray';
      }
    },
    // 获取条件状态默认文案（当没有button_name时使用）
    getConditionStatusText(status) {
      switch (status) {
        case 0:
          return '未完成';
        case 10:
          return '领取';
        case 20:
          return '已完成';
        default:
          return '未完成';
      }
    },
    // API接口 - 获取小红书活动详情
    async getPrizeDetail() {
      if (!this.activity_id) {
        this.error = '缺少活动ID参数';
        return;
      }
      try {
        this.loading = true;
        this.error = '';
        const response = await getDrawInfoDetail({
          activity_id: this.activity_id
        });
        if (response && response.status === 0) {
          // 解析数据模型
          // 直接使用response.data赋值给prizeModel

          this.prizeModel = response.data;
          this.prizeModel.prize_list = response.data.prize_list || [];
          this.prizeModel.condition_list = response.data.condition_list || [];
        } else {
          this.error = (response === null || response === void 0 ? void 0 : response.message) || '获取活动详情失败';
          console.error('API Error:', response);
        }
      } catch (err) {
        this.error = '网络请求失败，请稍后重试';
        console.error('Request Error:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};